import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { clearAuthenticatedUser } from "../../helpers/auth-session";

const SignedOut = () => {
  const location = useLocation();
  const [incomplete] = useState(() => {
    const failed =
      new URLSearchParams(location.search).get("microsoft") === "incomplete";
    try {
      return (
        failed ||
        sessionStorage.getItem("piers.microsoft-signout") === "incomplete"
      );
    } catch {
      return failed;
    }
  });
  useEffect(() => {
    clearAuthenticatedUser();
    try {
      sessionStorage.removeItem("piers.microsoft-signout");
    } catch {
      /* Optional UI marker. */
    }
  }, []);
  return (
    <Navigate
      replace
      to={`/signin?signedOut=true${incomplete ? "&microsoft=incomplete" : ""}`}
    />
  );
};
export default SignedOut;
